import { IDeleteMultipleBaseRequest } from '../../models/request/base/deleteRequest';
import { IBusBaoCaoDiemDanhRequest, IBusTuyenDuongSelectRequest } from '../../models/request/bus/busBaoCaoDiemDanhRequest';
import { IUploadExcelRequest } from '../../models/request/bus/uploadExcelRequest';
import { bus_tuyenduong } from '../../models/response/bus/bus_tuyenduong';
import { apiClient } from '../apiClient';
import { BaseCRUDApi } from '../baseCRUDApi';

export const API_BUS_TUYENDUONG_PATH = "bus/tuyen-duong";

export interface IBusTuyenDuongSelectByLoaiDiemDonRequest extends IBusTuyenDuongSelectRequest {
	bus_loaidiemdon_id: number;
}
export interface IBusTuyenDuongSelectChuaPhanTuyenRequest extends IBusTuyenDuongSelectRequest {
	bus_diemdontra_id: number;
}
export interface IBusTuyenDuongUpdatePhanTuyenHocSinhRequest {
	bus_tuyenduong_id: number;
	bus_dangkyxe_ids: number[];
}

class BusTuyenDuongApi extends BaseCRUDApi<bus_tuyenduong> {
	// eslint-disable-next-line @typescript-eslint/no-useless-constructor
	constructor(path: string) {
		super(path);
	}
	SelectAsync(request: IBusTuyenDuongSelectRequest) {
		return apiClient.post(`${API_BUS_TUYENDUONG_PATH}/select`, {
			nam_hoc: request.nam_hoc,
			dm_coso_id: request.dm_coso_id,
		});
	}
	SelectByLoaiDiemDonAsync(request: IBusTuyenDuongSelectByLoaiDiemDonRequest) {
		return apiClient.post(`${API_BUS_TUYENDUONG_PATH}/select-by-loaidiemdon`, {
			nam_hoc: request.nam_hoc,
			dm_coso_id: request.dm_coso_id,
			bus_loaidiemdon_id: request.bus_loaidiemdon_id,
		});
	}
	SelectPhanTuyenAsync(request: IBusTuyenDuongSelectRequest) {
		return apiClient.post(`${API_BUS_TUYENDUONG_PATH}/select-phan-tuyen`, {
			nam_hoc: request.nam_hoc,
			dm_coso_id: request.dm_coso_id,
		});
	}
	SelectBaoCaoDiemDanhAsync(request: IBusBaoCaoDiemDanhRequest) {
		return apiClient.post(`${API_BUS_TUYENDUONG_PATH}/bao-cao-diem-danh`, {
			nam_hoc: request.nam_hoc,
			dm_coso_id: request.dm_coso_id,
			bus_tuyenduong_id: request.bus_tuyenduong_id,
			ngay_diem_danh: request.ngay_diem_danh,
		});
	}
	SelectChuaPhanTuyenAsync(request: IBusTuyenDuongSelectChuaPhanTuyenRequest) {
		return apiClient.post(`${API_BUS_TUYENDUONG_PATH}/select-chua-phan-tuyen`, {
			nam_hoc: request.nam_hoc,
			dm_coso_id: request.dm_coso_id,
			bus_diemdontra_id: request.bus_diemdontra_id,
		});
	}
	UpdatePhanTuyenHocSinhAsync(request: IBusTuyenDuongUpdatePhanTuyenHocSinhRequest) {
		return apiClient.post(`${API_BUS_TUYENDUONG_PATH}/update-phan-tuyen-hoc-sinh`, {
			bus_tuyenduong_id: request.bus_tuyenduong_id,
			bus_dangkyxe_ids: request.bus_dangkyxe_ids,
		});
	}
	DeletesAsync(request: IDeleteMultipleBaseRequest) {
		return apiClient.post(`${API_BUS_TUYENDUONG_PATH}/deletes`, request);
	}
	SelectByCoSo(dm_coso_id: number) {
		return apiClient.get(`co-so/${dm_coso_id}/bus/tuyen-duong`);
	}
	SelectByDiemDonTra(bus_diemdontra_id: number) {
		return apiClient.get(`bus-diemdontra/${bus_diemdontra_id}/bus/tuyen-duong`);
	}
	SelectTuyenDuongChiTiet(bus_tuyenduong_id: number) {
		return apiClient.get(`bus/tuyen-duong/tuyen-duong-chi-tiet/${bus_tuyenduong_id}`);
	}
	Detail(id: number) {
		return apiClient.get(`${API_BUS_TUYENDUONG_PATH}/${id}`);
	}
	Import(request: IUploadExcelRequest) {
		return apiClient.put(`bus/tuyen-duong/import`, request);
	}
	ValidateImport(request: IUploadExcelRequest) {
		return apiClient.put(`bus/tuyen-duong/validate-import`, request);
	}
}
export const busTuyenDuongApi = new BusTuyenDuongApi(API_BUS_TUYENDUONG_PATH);
